import React, { useState, useEffect, useRef } from 'react'
import cssLogin from './Login.module.scss'
import {
    LoadingMask, 
    AlertWindow, 
    CredentialMultiInWindow, 
    ClientGatewayInPackage, 
    GlobalLibs, 
    AAALibs, 
    RoutePathLibs, 
    PackageVariablesLibs
} from 'bc-react-package'
import BackgroundImagePath from "../Resources/Images/Login/LoginBG.png"; // 給Preload Image使用
// #region Constant
const COMP_NAME = "Login"
// #endregion Constant

// #region Member Variables
let mblnInitialized = false
let mblnIfNeed2GoToApplicationHomePage = null
let mfuncUnListenHistoryEventHandler = null
let mstrUserName = ""
let mstrPassword = ""
let mstrClassID = ""
// #endregion Member Variables

function Login(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("")
    const [className, setClassID] = useState("")

    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    const [showCredentialMultiIn, setShowCredentialMultiIn] = useState(false)
    const [credentialMultiInArguments, setCredentialMultiInArguments] = useState(null)

    const [backgroundImageLoaded, setBackgroundImageLoaded] = useState(false)

    const [showOnFocusTitleForClassID, setShowOnFocusTitleForClassID] = useState(false)
    const [showOnFocusTitleForUserName, setShowOnFocusTitleForUserName] = useState(false)
    const [showOnFocusTitleForPassword, setShowOnFocusTitleForPassword] = useState(false)
    
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)

    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region Init Ref
    let mrefTxtPassword = useRef(null)
    // #endregion Init Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mblnIfNeed2GoToApplicationHomePage = RoutePathLibs.CheckIfNeed2GoToApplicationHomePage(props.history)
        console.log(COMP_NAME + ".Begin: mblnIfNeed2GoToApplicationHomePage: ", mblnIfNeed2GoToApplicationHomePage)
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)

        mstrUserName = ""
        mstrPassword = ""
        mstrClassID = ""
    }
    // #endregion First Launch

    // richard: render Google Login Button when Web 
    if (
        (!window.gConfig.ForChina) &&
        (!window.gSession.App.InApp)
        )
    {
        // Render 必須每次 都執行，不然畫面重新Render Google按鈕會消失  Tim23.03.15
        // 要加上 CN的判斷，不然 DCP上到CN RenderGoogleLoginButton 會一直跳錯       Tim23.09.11

        let objButtonParams = {
            width: 480,
            prompt_parent_id: "btnGoogleLoginGSI"
        }
        // richard: 20230315
        // 設 timeout 是不得已的，如果不設 當 Logout 回到這頁，會無法 Render
        setTimeout(function(e) {
            window.GoogleOAuthLibs.RenderGoogleLoginButton(BackFromWebCallbackGoogleLogin, null, objButtonParams)
        }, 10)
    } // end of if (!window.gSession.App.InApp)

    // #region useEffect
    useEffect(() => {
        mstrClassID = className
    }, [className])

    useEffect(() => {
        mstrUserName = userName
    }, [userName])

    useEffect(() => {
        mstrPassword = password

        if(password === "")
        {
            // 送出後 密碼錯誤後 的顯示處理
            setShowOnFocusTitleForPassword(false)
            if(mrefTxtPassword.current !== null)
            {
                mrefTxtPassword.current.placeholder = window.gAppUI.LBL_PasswordPlaceHolder
            }
        }
    }, [password])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        if (!mblnIfNeed2GoToApplicationHomePage)
        {
            let objWindowRefs = {
                OpenLoadingMask: OpenLoadingMask,
                CloseLoadingMask: CloseLoadingMask,
                ShowAlert: ShowAlert,
                ShowCredentialMultiInWindow: ShowCredentialMultiInWindow
            }
            // AAALibs.RegisterCallerWindownFuncRefs(objWindowRefs)
            GlobalLibs.RegisterCallerWindownFuncRefs(objWindowRefs)

            mrefPaintedMe.current()
        }

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            if (!mblnIfNeed2GoToApplicationHomePage)
            {
                // AAALibs.UnRegisterCallerWindownFuncRefs()
                GlobalLibs.UnRegisterCallerWindownFuncRefs()

                mfuncUnListenHistoryEventHandler()
            }
            mblnInitialized = false
            mstrUserName = ""
            mstrPassword = ""
            mstrClassID = ""
        }
    }, [])
    // #endregion useEffect

    // #region Painted Me
    function PaintedMe()
    {
        const FUNC_NAME = "PaintedMe"
        console.log(COMP_NAME + "." + FUNC_NAME)

        // 打錯密碼，切到別頁後，回來 這頁 用來清除 Passwordgj 輸入框資料       註解Tim21.03.09
        mfuncUnListenHistoryEventHandler = props.history.listen((Location, Action) => {
            console.log(COMP_NAME + ".history.listen: ", Action, Location)
            if (
                (typeof (Location.state) !== "undefined") &&
                (Location.state.LoginFailed)
                )
            {
                console.log("Login Failed, need to clear password!")
                setPassword("")
            }
        })

        LoadBackgroundImage()
    }
    // #endregion Painted Me

    // #region OnTapHandler

    // 點選 Login 按鈕
    function LoginOnTapHandler()
    {
        console.log(COMP_NAME + ".LoginOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        ShowOnFocusTitle()
        LoginWithAccPwd(mstrClassID, mstrUserName, mstrPassword)
    }

    // 點選 GoogleLogin 按鈕
    function GoogleLoginOnTapHandler()
    {
        console.log(COMP_NAME + ".GoogleLoginOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (window.gSession.App.InApp)
        {
            CallAppRegisterWithGoogle()
        }
        // richard: 20230721 目前 Google Web Login 已經不允許自訂 Login Button
        // else
        // {
        //     console.log("GoogleLoginOnTapHandler on Web Page")
        //     window.GoogleOAuthLibs.SignIn(BackFromWebCallbackGoogleLogin, null)
        // }
    }

    function AppleLoginOnTapHandler()
    {
        console.log(COMP_NAME + ".AppleLoginOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (window.gSession.App.InApp)
        {
            CallAppRegisterWithApple()
        }
        else
        {
            console.log("AppleLoginOnTapHandler on Web Page")
            window.AppleOAuthLibs.SignIn(BackFromWebCallbackAppleLogin, null)
        }
    }

    // 點選 忘記密碼 按鈕
    function ForgotPasswordOnTapHandler()
    {
        console.log(COMP_NAME + ".ForgotPasswordOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        RoutePathLibs.Route2Path(props.history, "/ForgotPassword")
    }

    // 點選 註冊 按鈕
    function SignUpOnTapHandler()
    {
        console.log(COMP_NAME + ".SignUpOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        RoutePathLibs.Route2Path(props.history, "/CreateAccount")
    }

    /*===========================================
    summary: 點選 中國 ICP案號 
    remarks: 000 Tim 2022/01/26 Create
    ===========================================*/
    function ICPVersionOnTapHandler()
    {
        console.log(COMP_NAME + ".ICPVersionOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrl = window.gConfig.ICPUrl
        console.log("ICPVersionOnTapHandler strUrl: ", strUrl)

        window.open(strUrl)
    } // end of ICPVersionOnTapHandler
    // #endregion OnTapHandler


    // #region Other Handler

    function LoadBackgroundImage()
    {
        console.log(COMP_NAME + ".LoadBackgroundImage: ")

        let objImage = new Image()
        objImage.onload = function ()
        {
            BackgroundImageLoadedHandler()
        };
        objImage.src = BackgroundImagePath
    }

    // 圖片讀取完成後要做的處理
    function BackgroundImageLoadedHandler()
    {
        console.log(COMP_NAME + ".BackgroundImageLoadedHandler: ")
        setBackgroundImageLoaded(true)        
    }

    function ShowOnFocusTitle()
    {
        const FUNC_NAME = "showOnFocusTitle"
        console.log(COMP_NAME + "." + FUNC_NAME)

        if(mstrClassID !== "")
        {
            setShowOnFocusTitleForClassID(true)    
        }

        if(mstrUserName !== "")
        {
            setShowOnFocusTitleForUserName(true)  
        }

        if(mstrPassword !== "")
        {
            setShowOnFocusTitleForPassword(true)
        }
    }

    // 輸入框 鍵盤離開事件
    function InputKeyUpHandler(e)
    {
        console.log(COMP_NAME + ".InputKeyUpHandler: ", e)

        if (e.keyCode === 13)
        {
            e.preventDefault()
            e.target.blur() // 避免彈出帳密錯誤的Alert Message時 使用者又再按Enter 再次觸發此事件

            ShowOnFocusTitle()

            LoginWithAccPwd(mstrClassID, mstrUserName, mstrPassword)
        }
    }

    // 班級名稱 改變 事件
    function ClassIDChangeHandler(e)
    {
        console.log(COMP_NAME + ".ClassIDChangeHandler: ", e)
        setClassID(e.target.value)
    }

    // 使用者名稱 改變 事件
    function UserNameChangeHandler(e)
    {
        console.log(COMP_NAME + ".UserNameChangeHandler: ", e)
        setUserName(e.target.value)
    }

    // 密碼 改變 事件
    function PasswordChangeHandler(e)
    {
        console.log(COMP_NAME + ".PasswordChangeHandler: ", e)
        setPassword(e.target.value)
    }

    function ClassIDOnFocusHandler(Event)
    {
        const FUNC_NAME = "ClassIDOnFocusHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        console.log(COMP_NAME + "." + FUNC_NAME + " Event:", Event)
        setShowOnFocusTitleForClassID(true)

        Event.target.placeholder = "" // 將 placeholder 設為空字串
    }

    function ClassIDOnBlurHandler(Event)
    {
        const FUNC_NAME = "ClassIDOnBlurHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        if(Event.target.value.trim() !== "")
        {
            // 有輸入字
            Event.target.placeholder = ""
            setShowOnFocusTitleForClassID(true)
        }
        else
        {
            // 無輸入任何字
            Event.target.placeholder = window.gAppUI.LBL_ClassIDPlaceHolder // 將 placeholder 還原
            setShowOnFocusTitleForClassID(false)
        }
    }

    function UserNameOnFocusHandler(Event)
    {
        const FUNC_NAME = "UserNameOnFocusHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        // console.log(COMP_NAME + "." + FUNC_NAME + " Event:", Event)
        Event.target.placeholder = ""
        setShowOnFocusTitleForUserName(true)
    }

    function UserNameOnBlurHandler(Event)
    {
        const FUNC_NAME = "UserNameOnBlurHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        if(Event.target.value.trim() !== "")
        {
            // 有輸入字
            Event.target.placeholder = ""
            setShowOnFocusTitleForUserName(true)
        }
        else
        {
            // 無輸入任何字
            Event.target.placeholder = window.gAppUI.LBL_UserNamePlaceHolder // 將 placeholder 還原
            setShowOnFocusTitleForUserName(false)
        }
    }

    function PasswordOnFocusHandler(Event)
    {
        const FUNC_NAME = "PasswordOnFocusHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        console.log(COMP_NAME + "." + FUNC_NAME + " Event:", Event)
        setShowOnFocusTitleForPassword(true)

        Event.target.placeholder = "" // 將 placeholder 設為空字串
    }

    function PasswordOnBlurHandler(Event)
    {
        const FUNC_NAME = "PasswordOnBlurHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        if(Event.target.value.trim() !== "")
        {
            // 有輸入字
            Event.target.placeholder = ""
            setShowOnFocusTitleForPassword(true)
        }
        else
        {
            // 無輸入任何字
            Event.target.placeholder = window.gAppUI.LBL_PasswordPlaceHolder // 將 placeholder 還原
            setShowOnFocusTitleForPassword(false)
        }
    }

    // #endregion Other Handler

    // #region LoadingMask and Alert

    // 開啟 讀取中 效果
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    }

    // 關閉 讀取中 效果
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    }

    // 顯示 提示視窗
    function ShowAlert(AlertObject)
    {
        setAlertObject(AlertObject)
        setShowAlert(true)
    }

    // 關閉 提示視窗
    function HideAlert()
    {
        setAlertObject(null)
        setShowAlert(false)
    }

    /*===========================================
    summary: 開啟 多重登入 阻擋視窗
    remarks: 000 Tim 2022/11/02 Create
    ===========================================*/
    function ShowCredentialMultiInWindow(Title, Message)
    {
        let objCredentialMultiInArguments = {
            "Title": Title,
            "Message": Message
        }
        setCredentialMultiInArguments(objCredentialMultiInArguments)
        setShowCredentialMultiIn(true)
    } // end of ShowCredentialMultiInWindow
    // #endregion LoadingMask and Alert

    // #region Alert Callback

    function GoogleSignInFailAlertCallback (BtnObject)
    {
        console.log(COMP_NAME + ".GoogleSignInFailAlertCallback: BtnObject: ", BtnObject)

        if (BtnObject.index === 0) // BTN_OK
        {
            AAALibs.OAuthNormalLogout(AAALibs.OAuthProviderTypeEnum.Google)
        }
    }

    // #endregion Alert Callback

    // #region Component Callback
    // #endregion Component Callback

    // #region Other Functions

    // componentDidMount 程式進入 處理Props資料
    

    // 執行 帳號密碼登入
    function LoginWithAccPwd(ClassName, LoginName, Password)
    {
        console.log("LoginWithAccPwd: ", ClassName, LoginName, Password)

        let strClassName = ClassName
        let strLoginName = LoginName
        let strPassword = Password

        let blnValidData = false

        if (
            (strLoginName !== "") &&
            (strPassword !== "")
            )
        {
            blnValidData = true
        }
        else
        {
            // LoginName or Password cannot be empty
            let objAlertObject = {
                Header: null,
                Body: window.gAppUI.ERR_InputUsernameAndPassword,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [{
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }]
            }
            ShowAlert(objAlertObject)
        }

        if (blnValidData)
        {
            AAALibs.UserLogin(strClassName, strLoginName, strPassword)
        }
    }

    // #region OAuth - GoogleSignIn, FacebookLogin and AppleSignIn

    /*===========================================
    summary: App 執行 Google登入
    remarks: 000 Jeff 2022/08/XX Create
             001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function CallAppRegisterWithGoogle()
    {
        console.log(COMP_NAME + ".CallAppRegisterWithGoogle")
        let intAction = window.gConst.ACTION_OAUTH_GOOGLE_REG
        let strQueryString = "Action=" + intAction + "&Credential=&BackRoute="
        console.log("strQueryString: ", strQueryString)
        
        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway, BackFromAppCallbackRegisterWithGoogle)
        ClientGatewayInPackage.CallApp(strQueryString, BackFromAppCallbackRegisterWithGoogle)
    } // end of CallAppRegisterWithGoogle

    // Google登入 App Callback
    // remarks: 001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    function BackFromAppCallbackRegisterWithGoogle(ReturnData, CallbackObj)
    {
        console.log(COMP_NAME + ".BackFromAppCallbackRegisterWithGoogle: ", ReturnData, CallbackObj)

        // window.gSession.App.AppCallbackRef = null

        if (
            (typeof (ReturnData) !== 'undefined') &&
            (ReturnData !== null) &&
            (typeof (ReturnData.bcSignInStatusCode) !== 'undefined') &&
            (ReturnData.bcSignInStatusCode !== null)
            )
        {
            console.log("ReturnData.bcSignInStatusCode: ", ReturnData.bcSignInStatusCode)

            if(parseInt(ReturnData.bcSignInStatusCode) === 1)
            {
                console.log("OAuthLogin")
                // Web in App - Google Sign In 跳出驗證視窗 App回傳使用者授權成功
                AAALibs.OAuthLogin(ReturnData, AAALibs.OAuthProviderTypeEnum.Google)
            }
            else if (
                (parseInt(ReturnData.bcSignInStatusCode) === -1) &&
                (ReturnData.ResultMsg.toLowerCase().indexOf("invalid_grant") !== -1)
                )
            {
                console.log(COMP_NAME + ".BackFromAppCallbackRegisterWithGoogle  OAuthLoginFailAlert invalid_grant")

                // e.g. 舊版的登出 不是用Google Sign Out 所以可能一直使用同一個帳號的舊的access token 若放很久後再使用 ReturnData.bcSignInStatusCode 就會是 -1 走到這裡跳訊息並強制登出

                // 登入失敗，先跳提示視窗
                // 再強制執行登出，讓他下次登入流程恢復正常     Tim23.03.16
                let objAlertObject = {
                    Header: null,
                    Body: window.gAppUI.MSG_Alert_GoogleSignInFail,
                    ShowCloseButton: false,
                    CallbackRef: GoogleSignInFailAlertCallback,
                    Buttons: [
                        {
                            Text: PackageVariablesLibs.UISettings.BTN_OK,
                            AutoFocus: true
                        }
                    ]
                }
                ShowAlert(objAlertObject)
            } // end of else if (ReturnData.ResultMsg.toLowerCase().indexOf("invalid_grant") !== -1)
            else
            {
                // 使用者 按取消 所以不做任何事 or 其他錯誤
                console.log(COMP_NAME + ".BackFromAppCallbackRegisterWithGoogle GoogleSignIn Error ResultMsg: ", ReturnData.ResultMsg)
            } // end of else
        }
        else
        {
            console.log(COMP_NAME + ".BackFromAppCallbackRegisterWithGoogle GoogleSignIn 回傳 參數錯誤")
        }
    }   

    // // App 執行 Facebook登入
    // function CallAppRegisterWithFacebook()
    // {
    //     console.log(COMP_NAME + ".CallAppRegisterWithFacebook")
    //     let intAction = window.gConst.ACTION_OAUTH_FB_REG
    //     let strQueryString = "Action=" + intAction + "&Credential=&BackRoute="
    //     console.log("strQueryString: ", strQueryString)

    //     ClientGatewayInPackage.CallApp(strQueryString, BackFromAppCallbackRegisterWithFacebook)
    // }

    // Facebook登入 App Callback
    // function BackFromAppCallbackRegisterWithFacebook(ReturnData, CallbackObj)
    // {
    //     console.log(COMP_NAME + ".BackFromAppCallbackRegisterWithFacebook: ", ReturnData, CallbackObj)
    //     if (
    //         (typeof (ReturnData) !== 'undefined') &&
    //         (ReturnData !== null) &&
    //         (typeof (ReturnData.bcSignInStatusCode) !== 'undefined') &&
    //         (ReturnData.bcSignInStatusCode !== null) &&
    //         (parseInt(ReturnData.bcSignInStatusCode) === 1)
    //     )
    //     {
    //         // Web in App - Apple Sign In 跳出驗證視窗 App回傳使用者授權成功
    //         AAA.OAuthLogin(ReturnData, AAA.OAuthProviderTypeEnum.Facebook)
    //     }
    //     else
    //     {
    //         console.log("FacebookLogin 使用者取消驗證 未成功")
    //         // 使用者 按取消 所以不做任何事
    //     }
    // }

    /*===========================================
    summary: App 執行 Apple登入
    remarks: 000 Jeff 2022/08/XX Create
             001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function CallAppRegisterWithApple()
    {
        console.log(COMP_NAME + ".CallAppRegisterWithApple")
        let intAction = window.gConst.ACTION_OAUTH_APPLE_REG
        let strQueryString = "Action=" + intAction + "&Credential=&BackRoute="
        console.log("strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway, BackFromAppCallbackRegisterWithApple)
        ClientGatewayInPackage.CallApp(strQueryString, BackFromAppCallbackRegisterWithApple)
    } // end of CallAppRegisterWithApple

    // Apple登入 App Callback
    // remarks: 001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    function BackFromAppCallbackRegisterWithApple(ReturnData, CallbackObj)
    {
        console.log(COMP_NAME + ".BackFromAppCallbackRegisterWithApple: ", ReturnData, CallbackObj)
        
        // window.gSession.App.AppCallbackRef = null

        if (
            (typeof (ReturnData) !== 'undefined') &&
            (ReturnData !== null) &&
            (typeof (ReturnData.bcSignInStatusCode) !== 'undefined') &&
            (ReturnData.bcSignInStatusCode !== null) &&
            (parseInt(ReturnData.bcSignInStatusCode) === 1)
            )
        {
            // Web in App - Apple Sign In 跳出驗證視窗 App回傳使用者授權成功
            AAALibs.OAuthLogin(ReturnData, AAALibs.OAuthProviderTypeEnum.Apple)
        }
        else
        {
            console.log("AppleSignIn 使用者取消驗證 未成功")
            // 使用者 按取消 所以不做任何事
        }
    }

    // Google登入 Web Callback
    function BackFromWebCallbackGoogleLogin(ReturnData, CallbackObj)
    {
        console.log(COMP_NAME + ".BackFromWebCallbackGoogleLogin: ", ReturnData, CallbackObj)

        AAALibs.OAuthLogin(ReturnData, AAALibs.OAuthProviderTypeEnum.Google)
    }

    // Facebook登入 Web Callback
    // function BackFromWebCallbackFBLogin(ReturnData, CallbackObj)
    // {
    //     console.log(COMP_NAME + ".BackFromWebCallbackFBLogin: ", ReturnData, CallbackObj)

    //     AAA.OAuthLogin(ReturnData, AAA.OAuthProviderTypeEnum.Facebook)
    // }

    // Apple登入 Web Callback
    function BackFromWebCallbackAppleLogin(ReturnData, CallbackObj)
    {
        console.log(COMP_NAME + ".BackFromWebCallbackAppleLogin: ", ReturnData, CallbackObj)

        AAALibs.OAuthLogin(ReturnData, AAALibs.OAuthProviderTypeEnum.Apple)
    }
    // #endregion OAuth - GoogleSignIn, FacebookLogin and AppleSignIn

    // #endregion Other Functions

    // #region Get ClassName or Style

    function GetClsOnFocusTitle(ShowOnFocusTitle)
    {
        const FUNC_NAME = "GetClsOnFocusTitle"
        console.log(COMP_NAME + "." + FUNC_NAME)

        let objCls = null
        if(ShowOnFocusTitle)
        {
            objCls = cssLogin.divInputOnFocusTitle
        }
        else
        {
            objCls = cssLogin.divHidden
        }
        return objCls
    }

    // Get GoogleLogin 按鈕 Cls
    function GetClsGoogleLoginButton()
    {
        let objCls = {
            "Button": cssLogin.btnGoogleLoginDisabled,
            "Icon": cssLogin.divGoogleLogoDisabled,
            "Text": cssLogin.divGoogleTextDisabled
        }

        if (
            ((!window.gSession.App.InApp) && window.GoogleOAuthLibs.IsSDKLoaded()) ||
            (window.gSession.App.InApp) // InApp
        )
        {
            objCls = {
                "Button": cssLogin.btnGoogleLogin,
                "Icon": cssLogin.divGoogleLogo,
                "Text": cssLogin.divGoogleText
            }
        }
        return objCls
    }

    function GetClsBackgroundImage()
    {
        let objCls = null
        if(backgroundImageLoaded)
        {
            console.log("cssLogin.divBG")
            objCls = cssLogin.divBG
        }
        else
        {
            console.log("cssLogin.divBGThumbnail")
            objCls = cssLogin.divBGThumbnail
        }
        return objCls
    }

    // 取得 FacebookLogin 按鈕 Cls
    // function GetClsFacebookLoginButton()
    // {
    //     let objCls = {
    //         "Button": cssLogin.btnFacebookLoginDisabled,
    //         "Icon": cssLogin.divFacebookLogoDisabled,
    //         "Text": cssLogin.divFacebookTextDisabled
    //     }
    //     if (
    //        ((!window.gSession.App.InApp) && window.FBOAuthLibs.IsSDKLoaded()) || // Web
    //        (window.gSession.App.InApp) // InApp
    //        )
    //     {
    //         objCls = {
    //             "Button": cssLogin.btnFacebookLogin,
    //             "Icon": cssLogin.divFacebookLogo,
    //             "Text": cssLogin.divFacebookText
    //         }
    //     }
    //     return objCls
    // }

    // 取得 AppleLogin 按鈕 Cls
    function GetClsAppleSignInButton()
    {
        let objCls = {
            "Button": cssLogin.btnAppleLoginDisabled,
            "Icon": cssLogin.divAppleLogoDisabled,
            "Text": cssLogin.divAppleTextDisabled
        }

        if (
            ((!window.gSession.App.InApp) && window.AppleOAuthLibs.IsSDKLoaded()) || // Web
            (window.gSession.App.InApp) // InApp
        )
        {
            objCls = {
                "Button": cssLogin.btnAppleLogin,
                "Icon": cssLogin.divAppleLogo,
                "Text": cssLogin.divAppleText
            }
        }

        return objCls
    }
    // #endregion Get ClassName or Style

    // #region Component
    /*===========================================
    summary: 中國 ICP案號 顯示 Component
    remarks: 000 Tim 2022/01/26 Create
    ===========================================*/
    function ComponentICPVersion( {ForChina} )
    {
        if (ForChina)
        {
            return (
                <div className={cssLogin.btnICPVersion} onClick={() => ICPVersionOnTapHandler()}>
                    {window.gAppUI.BTN_ICPVersion}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of ComponentICPVersion

    // SignUp 顯示Component
    function ComponentSignUp()
    {
        return (
            <div className={cssLogin.divSignUpArea}>
                <div className={cssLogin.divDontHaveAccount}>
                    {window.gAppUI.LBL_SignUpMsg}
                </div>
                <div className={cssLogin.btnSignUp} onClick={(event) => SignUpOnTapHandler(event)}>
                    {window.gAppUI.LBL_SignUp}
                </div>
            </div>
        )
    }

    // Facebook登入按鈕 顯示Component
    // function ComponentFacebookLogin() 
    // {   
    //     let objCls = GetClsFacebookLoginButton()
    //     return(
    //         <div className={objCls.Button} onClick={() => FacebookLoginOnTapHandler()}>
    //             <div className={objCls.Icon}/>
    //             <div className={objCls.Text}>
    //                 {window.gAppUI.LBL_FacebookLogin}
    //             </div>
    //         </div>
    //     )
    // }

    // Apple登入按鈕 顯示Component
    function ComponentAppleLogin()
    {
        let objCls = GetClsAppleSignInButton()
        return (
            <div className={objCls.Button} onClick={() => AppleLoginOnTapHandler()}>
                <div className={objCls.Icon}/>
                <div className={objCls.Text}>
                    {window.gAppUI.LBL_AppleSignIn}
                </div>
            </div>
        )
    }

    // Google登入按鈕 顯示Component
    function ComponentGoogleLogin({ForChina})
    {
        if (!ForChina)
        {
            let objCls = GetClsGoogleLoginButton()

            let objBlock = null
            if (!window.gSession.App.InApp)
            {
                objBlock =  <div className={cssLogin.btnGoogleLoginBorder}>
                                <div className={objCls.Button}>
                                    <div className={objCls.Icon} />
                                    <div className={objCls.Text}>
                                        {window.gAppUI.LBL_GoogleSignIn}
                                    </div>
                                </div>

                                <div id="btnGoogleLoginGSI" className={cssLogin.btnGoogleLoginWeb}/> 
                            </div>
            }
            else
            {
                objBlock =  <div className={cssLogin.btnGoogleLoginBorder}>
                                <div className={objCls.Button} onClick={() => GoogleLoginOnTapHandler()}>
                                        <div className={objCls.Icon} />
                                        <div className={objCls.Text}>
                                        {window.gAppUI.LBL_GoogleSignIn}
                                    </div>
                                </div>
                            </div>
            }
            return objBlock
        }
        else
        {
            return ""
        }
    }

    // 登入按鈕 顯示Component
    function ComponentLogin()
    {
        return (
            <div className={cssLogin.btnLogin} onClick={() => LoginOnTapHandler()}>
                {window.gAppUI.LBL_Login}
            </div>
        )
    }

    // 忘記密碼 顯示Component
    function ComponentForgotPassword()
    {
        return (
            <div className={cssLogin.divForgotPasswordRow}>
                <div className={cssLogin.btnForgotPassword} onClick={() => ForgotPasswordOnTapHandler()}>
                    {window.gAppUI.LBL_Forgot}
                </div>
            </div>
        )
    }

    /*===========================================
    summary: Version 顯示Component  
    remarks: 000 Tim 2022/11/23 Create
    ===========================================*/
    function ComponentVersion()
    {   
        let strVersion = window.gAppUI.LBL_Version + ": " + process.env.REACT_APP_LOG_VERSION

        // App 版號
        if (
            (typeof (window.gSession.App.AppVersion) !== 'undefined') &&
            (window.gSession.App.AppVersion !== null) &&
            (window.gSession.App.AppVersion !== "") &&
            (window.gSession.App.AppVersion !== "0.0.0.0")
            )
        {
            strVersion += " ("
            strVersion += window.gSession.App.AppVersion
            strVersion += ")"
        } // end of if (window.gSession.App.AppVersion !== "")

        // Package 版號
        if (
            (typeof (PackageVariablesLibs) !== 'undefined') &&
            (PackageVariablesLibs !== null) &&
            (typeof (PackageVariablesLibs.PackageVersion) !== 'undefined') &&
            (PackageVariablesLibs.PackageVersion !== null) &&
            (PackageVariablesLibs.PackageVersion !== "") &&
            (PackageVariablesLibs.PackageVersion !== "0.0.0")
            )
        {
            strVersion += " (pv-"
            strVersion += PackageVariablesLibs.PackageVersion
            strVersion += ")"
        } // end of if (PackageVariablesLibs.PackageVersion !== "")

        return(
            <div className={cssLogin.divVersion}>
                {strVersion}
            </div>
        )
    } // end of ComponentVersion
    // #endregion Component

    // #region Render

    // Render LoginButton 的顯示
    function RenderLoginButtonArea()
    {
        return (
            <div className={cssLogin.divLoginButtonArea}>
                <ComponentLogin />
                <ComponentGoogleLogin ForChina={window.gConfig.ForChina} />
                <ComponentAppleLogin />
                {/* <ComponentFacebookLogin /> */}
            </div>
        )
    }

    // InputPassword 顯示
    function RenderInputPasswordArea(StatePassword)
    {
        return (
            <div className={cssLogin.divInput4Password} onKeyUp={InputKeyUpHandler}>
                <label htmlFor="txtPassword" className={cssLogin.divHidden}>
                    {window.gAppUI.LBL_PasswordPlaceHolder}
                </label>
                <input
                    ref={mrefTxtPassword}
                    id="txtPassword"
                    className={cssLogin.txtInput}
                    type="password"
                    value={StatePassword}
                    placeholder={window.gAppUI.LBL_PasswordPlaceHolder}
                    onChange={(event) => PasswordChangeHandler(event)}
                    required
                    autoComplete="true"
                    onFocus={(event) => PasswordOnFocusHandler(event)}
                    onBlur={(event) => PasswordOnBlurHandler(event)}
                    />
                <div className={GetClsOnFocusTitle(showOnFocusTitleForPassword)}>
                    {window.gAppUI.LBL_PasswordPlaceHolder}
                </div>
            </div>
        )
    }

    // InputUserName 顯示
    function RenderInputUserName(StateUserName)
    {
        return (
            <div className={cssLogin.divInput} onKeyUp={InputKeyUpHandler}>
                <label htmlFor="txtUserName" className={cssLogin.divHidden}>
                    {window.gAppUI.LBL_UserNamePlaceHolder}
                </label>
                <input
                    id="txtUserName"
                    className={cssLogin.txtInput}
                    type="email"
                    value={StateUserName}
                    placeholder={window.gAppUI.LBL_UserNamePlaceHolder}
                    onChange={(event) => UserNameChangeHandler(event)}
                    required
                    autoComplete="true"
                    onFocus={(event) => UserNameOnFocusHandler(event)}
                    onBlur={(event) => UserNameOnBlurHandler(event)}
                    />
                <div className={GetClsOnFocusTitle(showOnFocusTitleForUserName)}>
                    {window.gAppUI.LBL_UserNamePlaceHolder}
                </div>
            </div>
        )
    }

    // InputClassName 顯示
    function RenderInputClassID(StateClassName)
    {
        return (
            <div className={cssLogin.divInput} onKeyUp={InputKeyUpHandler}>
                <label htmlFor="txtClassID" className={cssLogin.divHidden}>
                    {window.gAppUI.LBL_ClassIDPlaceHolder}
                </label>
                <input
                    id="txtClassID"
                    className={cssLogin.txtInput}
                    type="text"
                    value={StateClassName}
                    placeholder={window.gAppUI.LBL_ClassIDPlaceHolder}
                    onChange={(event) => ClassIDChangeHandler(event)}
                    required
                    autoComplete="true"
                    onFocus={(event) => ClassIDOnFocusHandler(event)}
                    onBlur={(event) => ClassIDOnBlurHandler(event)}
                    />
                <div className={GetClsOnFocusTitle(showOnFocusTitleForClassID)}>
                    {window.gAppUI.LBL_ClassIDPlaceHolder}
                </div>
            </div>
        )
    }

    // Render 輸入框區域 的顯示
    function RenderInputArea()
    {
        return (
            <div className={cssLogin.divInputArea}>
                {RenderInputClassID(className)}
                {RenderInputUserName(userName)}
                {RenderInputPasswordArea(password)}
            </div>
        )
    }

    function RenderContentArea()
    {
        return (
            <div className={cssLogin.divContent}>
                <div className={cssLogin.divLoginLogo} />
                {RenderInputArea()}
                <ComponentForgotPassword />
                {RenderLoginButtonArea()}
                {ComponentSignUp()}
            </div>
        )
    }

    function RenderMain()
    {
        let objBlock = null
        if (!mblnIfNeed2GoToApplicationHomePage)
        {
            objBlock = (
                <>
                    <div className={cssLogin.divMain}>
                        <div className={GetClsBackgroundImage()} />
                        <div className={cssLogin.divMask} />
                        {RenderContentArea()}

                        <ComponentICPVersion ForChina={window.gConfig.ForChina} />
                        <ComponentVersion />
                    </div>
                    <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
                    <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert} />
                    <CredentialMultiInWindow ShowCredentialMultiIn={showCredentialMultiIn} 
                        CredentialMultiInArguments={credentialMultiInArguments}/>
                </>
            )
        }
        return objBlock
    }

    return (
        <>
            {RenderMain()}
        </>
    )
    // #endregion Render
}
export default Login